import type { NotificationType } from '@st/contract';

/**
 * Naslovi obavijesti u portalu.
 *
 * Server šalje `titleKey` — konkretnu rečenicu („Zakazan ti je termin"). Zvonce
 * je taj ključ crtalo doslovno, pa je probna obavijest u popisu pisala
 * `notification.test`: ključ bez prijevoda ide korisniku na ekran kao da je
 * tekst. Ovdje je jedno mjesto koje to hvata — prevoditelj za nepoznat ključ
 * vraća sam ključ, i to je znak da treba pasti natrag na naziv vrste.
 */
export const TYPE_KEY: Record<NotificationType, string> = {
  workout_reminder: 'notif.typeWorkoutReminder',
  missed_workout: 'notif.typeMissedWorkout',
  new_program: 'notif.typeNewProgram',
  trainer_message: 'notif.typeTrainerMessage',
  progress_reminder: 'notif.typeProgressReminder',
  measurement_reminder: 'notif.typeMeasurementReminder',
  subscription_reminder: 'notif.typeSubscriptionReminder',
  payment_confirmation: 'notif.typePaymentConfirmation',
  payment_failed: 'notif.typePaymentFailed',
  weekly_summary: 'notif.typeWeeklySummary',
  reaction: 'notif.typeReaction',
  appointment_scheduled: 'notif.typeAppointmentScheduled',
  meal_logged: 'notif.typeMealLogged',
};

export interface NotificationLike {
  type: NotificationType;
  titleKey?: string | null;
  payload?: Record<string, unknown> | null;
}

export function notificationTitle(
  t: (key: string, vars?: Record<string, string | number>) => string,
  row: NotificationLike,
): string {
  const name = typeof row.payload?.name === 'string' ? row.payload.name : '';
  if (row.titleKey) {
    const prijevod = t(row.titleKey, { name });
    if (prijevod !== row.titleKey) return prijevod;
  }
  const vrsta = TYPE_KEY[row.type];
  const naziv = vrsta ? t(vrsta) : '';
  return naziv && naziv !== vrsta ? naziv : 'Soul Training';
}
